import { createRouter, createWebHistory } from 'vue-router'

import AccountView from '@/views/AccountView.vue';
import ApiSubscriptionsView from '@/views/ApiSubscriptionsView.vue';
import PaymentSuccessView from '@/views/PaymentSuccessView.vue';
import WidgetSubscriptionsView from '@/views/WidgetSubscriptionsView.vue';
import WidgetPaymentSuccessView from '@/views/WidgetPaymentSuccessView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: AccountView,
    },
    {
      path: '/api-subscriptions',
      name: 'api-subscriptions',
      component: ApiSubscriptionsView
    },
    {
      path: '/checkout-success',
      name: 'checkout-success',
      component: PaymentSuccessView,
    },
    {
      path: '/widget-subscriptions',
      name: 'widget-subscriptions',
      component: WidgetSubscriptionsView
    },
    {
      path: '/checkout-success-widget',
      name: 'checkout-success-widget',
      component: WidgetPaymentSuccessView,
    },
    // {
    //   path: '/referrals',
    //   name: 'referrals',
    //   component: ReferralsView
    // },
  ]
})

export default router
